import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DialogWidget: WidgetRegistryEntry = {
  name: "Dialog",
  configuration: () => import("./configuration").then((m) => m.DialogWidgetConfiguration),
  component: () => import("./dialog-widget.component").then((m) => m.DialogWidgetComponent)
};
